export const ROLE_TYPES = {
    ADMIN: 'admin',
    EDIT: 'edit',
    READ: 'read',
}

export const ROLES = [
    ROLE_TYPES.ADMIN,
    ROLE_TYPES.EDIT,
    ROLE_TYPES.READ,
]

export const PERMISSION_TYPES = {
    SCHEMA: 'schema',
    IMPORTS: 'imports',
    USERS: 'users',
}

export default {
    ROLES,
    ROLE_TYPES,
    PERMISSION_TYPES,
}
